// ABC SEO/GEO — Block 9: Backlinks (populated).
(function () {
  const { Icon } = window.SGIcons;
  const { Card, CardHead, Delta, PageHead } = window.SGKit;

  // Session cache of loaded backlink data, keyed by domain. Lets the user leave
  // the screen and come back to the SAME data instantly, with NO re-fetch (and
  // therefore no repeat DataForSEO charge). Cleared only on a full page reload.
  const _blCache = {};

  function StatRow({ stats }) {
    return (
      <Card style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', overflow: 'hidden' }}>
        {stats.map((s, i) => (
          <div key={s.label} style={{ padding: '18px 20px', borderLeft: i ? '1px solid var(--sg-border)' : 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 600, color: 'var(--sg-text-2)', marginBottom: 8 }}>{s.warn && <Icon name="alert-triangle" size={13} color="var(--sg-amber)" />}{s.label}</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
              {s.split
                ? <span className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 24, lineHeight: 1 }}><span style={{ color: 'var(--sg-green)' }}>24</span><span style={{ color: 'var(--sg-text-3)' }}> / </span><span style={{ color: 'var(--sg-red)' }}>9</span></span>
                : <span className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 26, letterSpacing: '-0.02em', color: s.warn ? 'var(--sg-amber)' : 'var(--sg-text)', lineHeight: 1 }}>{s.value}{s.sub && <span style={{ fontSize: 15, color: 'var(--sg-text-3)' }}>{s.sub}</span>}</span>}
              {s.delta && <Delta dir={s.dir}>{s.delta}</Delta>}
            </div>
          </div>
        ))}
      </Card>
    );
  }

  /* Real link profile — active vs lost referring domains + authority mix */
  function NewLostTrend({ refs }) {
    const list = refs || [];
    const active = list.filter((r) => !r.is_lost).length;
    const lost = list.filter((r) => r.is_lost).length;
    const total = active + lost;
    const auth = (r) => (r.rank != null ? Math.round(r.rank / 10) : 0);
    const strong = list.filter((r) => auth(r) >= 50).length;
    const mid = list.filter((r) => auth(r) >= 25 && auth(r) < 50).length;
    const low = list.filter((r) => auth(r) < 25).length;
    const bars = [
      { label: 'Active', n: active, c: 'var(--sg-green)' },
      { label: 'Lost', n: lost, c: 'var(--sg-red)' },
    ];
    const buckets = [
      { label: 'Strong (50+)', n: strong, c: 'var(--sg-green)' },
      { label: 'Medium (25–49)', n: mid, c: 'var(--sg-amber)' },
      { label: 'Low (<25)', n: low, c: 'var(--sg-text-3)' },
    ];
    return (
      <Card>
        <CardHead title="Link profile" sub={total ? `${total} referring domains analyzed` : 'Referring domains'}
          right={<span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>} />
        <div style={{ padding: 20 }}>
          {total === 0
            ? <div style={{ fontSize: 13, color: 'var(--sg-text-2)' }}>No referring domains found for this site yet.</div>
            : (
              <React.Fragment>
                <div style={{ display: 'flex', gap: 12, marginBottom: 18 }}>
                  {bars.map((b) => (
                    <div key={b.label} style={{ flex: 1, padding: '12px 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)' }}>
                      <div className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 24, color: b.c, lineHeight: 1 }}>{b.n}</div>
                      <div style={{ fontSize: 12, color: 'var(--sg-text-2)', marginTop: 4 }}>{b.label}</div>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', marginBottom: 10 }}>By authority</div>
                {buckets.map((bk, i) => (
                  <div key={bk.label} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: i < buckets.length - 1 ? 9 : 0 }}>
                    <span style={{ width: 96, fontSize: 12, color: 'var(--sg-text-2)' }}>{bk.label}</span>
                    <div style={{ flex: 1, height: 8, borderRadius: 999, background: 'var(--sg-sunken)', overflow: 'hidden' }}><div style={{ width: (total ? (bk.n / total * 100) : 0) + '%', height: '100%', borderRadius: 999, background: bk.c }} /></div>
                    <span className="sg-tnum" style={{ width: 28, textAlign: 'right', fontSize: 12.5, fontWeight: 700, color: 'var(--sg-text)' }}>{bk.n}</span>
                  </div>
                ))}
              </React.Fragment>
            )}
        </div>
      </Card>
    );
  }

  /* Real broken-backlinks callout (from the DataForSEO overview) */
  function ToxicCallout({ bl }) {
    const broken = (bl && bl.broken_backlinks) || 0;
    const ok = broken === 0;
    return (
      <Card style={{ padding: 22, display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
          <span style={{ width: 44, height: 44, borderRadius: 12, background: ok ? 'var(--sg-green-50)' : 'var(--sg-amber-50)', color: ok ? 'var(--sg-green)' : 'var(--sg-amber)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}><Icon name={ok ? 'check' : 'alert-triangle'} size={22} /></span>
          <div>
            <div className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 22, color: 'var(--sg-text)', lineHeight: 1 }}>{broken.toLocaleString()} broken link{broken === 1 ? '' : 's'}</div>
            <div style={{ fontSize: 12.5, color: 'var(--sg-text-2)', marginTop: 4 }}>{ok ? 'No broken backlinks found' : 'pointing to dead pages'}</div>
          </div>
        </div>
        <p style={{ fontSize: 13, color: 'var(--sg-text-2)', lineHeight: 1.55, margin: 0 }}>
          {ok
            ? 'None of your backlinks point to missing pages — your link equity is intact.'
            : 'These backlinks point to pages that return errors, wasting their link value. Set up redirects so the authority still counts.'}
        </p>
      </Card>
    );
  }

  function Auth({ v }) {
    const c = v >= 60 ? 'var(--sg-green)' : v >= 30 ? 'var(--sg-amber)' : 'var(--sg-red)';
    const bg = v >= 60 ? 'var(--sg-green-50)' : v >= 30 ? 'var(--sg-amber-50)' : 'var(--sg-red-50)';
    return <span className="sg-tnum" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 34, height: 24, padding: '0 8px', fontSize: 12.5, fontWeight: 700, color: c, background: bg, borderRadius: 'var(--sg-radius-sm)' }}>{v}</span>;
  }
  function TypePill({ t }) {
    const dofollow = t === 'Dofollow';
    return <span style={{ fontSize: 11.5, fontWeight: 700, color: dofollow ? 'var(--sg-blue-600)' : 'var(--sg-text-2)', background: dofollow ? 'var(--sg-blue-50)' : 'var(--sg-sunken)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>{t}</span>;
  }
  function StatusPill({ s }) {
    const m = { New: { c: 'var(--sg-green)', bg: 'var(--sg-green-50)' }, Lost: { c: 'var(--sg-red)', bg: 'var(--sg-red-50)' }, Active: { c: 'var(--sg-text-2)', bg: 'var(--sg-sunken)' } }[s];
    return <span style={{ fontSize: 11.5, fontWeight: 700, color: m.c, background: m.bg, padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>{s}</span>;
  }

  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmtSeen(s) {
    if (!s) return '—';
    const m = String(s).match(/^(\d{4})-(\d{2})/);
    if (!m) return '—';
    return MONTHS[Number(m[2]) - 1] + ' ' + m[1];
  }
  function LiveDomainRow({ r, last }) {
    const auth = r.rank != null ? Math.round(r.rank / 10) : 0; // DataForSEO rank 0–1000 → ~0–100
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px 70px 110px 110px 90px', alignItems: 'center', gap: 14, padding: '13px 20px', borderBottom: last ? 'none' : '1px solid var(--sg-border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          <span style={{ width: 26, height: 26, borderRadius: 7, background: 'var(--sg-sunken)', color: 'var(--sg-text-2)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}><Icon name="globe" size={14} /></span>
          <span style={{ fontSize: 13.5, fontWeight: 500, color: 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.domain}</span>
        </div>
        <Auth v={auth} />
        <span className="sg-tnum" style={{ fontSize: 13, color: 'var(--sg-text-2)' }}>{(r.backlinks ?? 0).toLocaleString()}</span>
        <span className="sg-tnum" style={{ fontSize: 12.5, color: 'var(--sg-text-2)' }}>{fmtSeen(r.first_seen)}</span>
        <span><TypePill t={r.dofollow != null && (r.dofollow * 2) < (r.backlinks || 1) ? 'Nofollow' : 'Dofollow'} /></span>
        <span style={{ justifySelf: 'start' }}><StatusPill s={r.is_lost ? 'Lost' : 'Active'} /></span>
      </div>
    );
  }

  // General, any-industry directories every business should have a link/citation on.
  const GENERAL_LINKS = [
    { domain: 'business.google.com', label: 'Google Business Profile', why: 'Strongest local signal — and a link to your site.' },
    { domain: 'bingplaces.com', label: 'Bing Places', why: 'Powers Bing + Copilot local results.' },
    { domain: 'businessconnect.apple.com', label: 'Apple Business Connect', why: 'Apple Maps + Siri listings.' },
    { domain: 'yelp.ca', label: 'Yelp', why: 'High-authority review profile with a dofollow link.' },
    { domain: 'bbb.org', label: 'Better Business Bureau', why: 'Trust signal AI engines read.' },
    { domain: 'yellowpages.ca', label: 'YellowPages.ca', why: 'Canada’s top general directory.' },
    { domain: 'linkedin.com', label: 'LinkedIn Company Page', why: 'High-DA profile + brand entity.' },
    { domain: 'foursquare.com', label: 'Foursquare', why: 'Syndicates to many maps/apps.' },
  ];

  function RelBadge({ kind }) {
    const m = kind === 'industry'
      ? { t: 'INDUSTRY', c: 'var(--sg-green)', bg: 'var(--sg-green-50)' }
      : { t: 'GENERAL', c: 'var(--sg-blue-600)', bg: 'var(--sg-blue-50)' };
    return <span style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '0.05em', color: m.c, background: m.bg, padding: '2px 7px', borderRadius: 'var(--sg-radius-pill)' }}>{m.t}</span>;
  }

  function Opportunities({ data, loading, you }) {
    const industry = (data && data.industry) || [];
    const needsCompetitors = data && data.needsCompetitors;
    return (
      <Card>
        <CardHead title="Link-building opportunities" sub="Industry-relevant sources first, then general directories every business should have."
          right={<span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-violet-700)', background: 'var(--sg-violet-100)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>PRIORITIZED</span>} />

        {/* Group 1 — industry-relevant (competitor link gap) */}
        <div style={{ padding: '12px 20px 6px', display: 'flex', alignItems: 'center', gap: 9 }}>
          <Icon name="target" size={15} color="var(--sg-green)" />
          <span style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--sg-text)' }}>From your industry</span>
          <span style={{ fontSize: 11.5, color: 'var(--sg-text-3)' }}>— sites that link to your competitors but not you</span>
        </div>
        {loading
          ? <div style={{ padding: '10px 20px 16px', fontSize: 13, color: 'var(--sg-text-2)' }}>Finding industry link sources…</div>
          : needsCompetitors
          ? <div style={{ margin: '4px 20px 14px', padding: 12, borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-amber-50)', border: '1px solid var(--sg-amber-100, #F6E6C7)', fontSize: 12.5, color: 'var(--sg-text)' }}>Add competitors for {you || 'this domain'} on the <strong>Competitors</strong> screen — we’ll surface the sites that link to them so you can earn the same links.</div>
          : industry.length === 0
          ? <div style={{ padding: '4px 20px 16px', fontSize: 12.5, color: 'var(--sg-text-3)' }}>No new industry link gaps found — you already share most referring domains with your competitors. 👍</div>
          : (
            <div style={{ padding: '0 8px 8px' }}>
              {industry.slice(0, 12).map((o, i) => {
                const auth = o.rank != null ? Math.round(o.rank / 10) : 0;
                return (
                  <div key={o.domain} style={{ display: 'grid', gridTemplateColumns: '1fr 70px 1fr 84px', alignItems: 'center', gap: 12, padding: '11px 12px', borderBottom: i < Math.min(12, industry.length) - 1 ? '1px solid var(--sg-border)' : 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 9, minWidth: 0 }}>
                      <RelBadge kind="industry" />
                      <span style={{ fontSize: 13.5, fontWeight: 500, color: 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{o.domain}</span>
                    </div>
                    <Auth v={auth} />
                    <span style={{ fontSize: 11.5, color: 'var(--sg-text-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>links to {o.fromCompetitors.join(', ')}</span>
                    <a href={'https://' + o.domain} target="_blank" rel="noopener noreferrer" style={{ justifySelf: 'end', display: 'inline-flex', alignItems: 'center', gap: 5, height: 30, padding: '0 12px', borderRadius: 'var(--sg-radius-pill)', border: '1px solid var(--sg-border)', background: 'var(--sg-card)', color: 'var(--sg-blue-600)', textDecoration: 'none', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12 }}>
                      Visit <Icon name="external-link" size={12} />
                    </a>
                  </div>
                );
              })}
            </div>
          )}

        {/* Group 2 — general, any-industry directories */}
        <div style={{ padding: '14px 20px 6px', borderTop: '1px solid var(--sg-border)', display: 'flex', alignItems: 'center', gap: 9 }}>
          <Icon name="globe" size={15} color="var(--sg-blue-600)" />
          <span style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--sg-text)' }}>General — every business should have these</span>
        </div>
        <div style={{ padding: '0 8px 12px' }}>
          {GENERAL_LINKS.map((g, i) => (
            <div key={g.domain} style={{ display: 'grid', gridTemplateColumns: '210px 1fr 84px', alignItems: 'center', gap: 12, padding: '11px 12px', borderBottom: i < GENERAL_LINKS.length - 1 ? '1px solid var(--sg-border)' : 'none' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9, minWidth: 0 }}>
                <RelBadge kind="general" />
                <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.label}</span>
              </div>
              <span style={{ fontSize: 12, color: 'var(--sg-text-2)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.why}</span>
              <a href={'https://' + g.domain} target="_blank" rel="noopener noreferrer" style={{ justifySelf: 'end', display: 'inline-flex', alignItems: 'center', gap: 5, height: 30, padding: '0 12px', borderRadius: 'var(--sg-radius-pill)', border: '1px solid var(--sg-border)', background: 'var(--sg-card)', color: 'var(--sg-blue-600)', textDecoration: 'none', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12 }}>
                Open <Icon name="external-link" size={12} />
              </a>
            </div>
          ))}
        </div>
      </Card>
    );
  }

  function Backlinks() {
    const { site, prettySite } = window.SGLive.useLive();
    const ent = window.SGLive.useEntitlement();
    const locked = ent.paidData === false;
    const dom = site ? prettySite(site) : undefined;
    const [bl, setBl] = React.useState(null);
    const [loaded, setLoaded] = React.useState(false);
    const [refs, setRefs] = React.useState(null);
    const [opps, setOpps] = React.useState(null);
    const [oppsLoading, setOppsLoading] = React.useState(false);
    const [started, setStarted] = React.useState(false);
    const [restoring, setRestoring] = React.useState(true);
    // On (re)open or domain switch, put back what we already have.
    // Two layers: the in-tab cache (instant), then the SERVER's week-long cache
    // (survives reloads and new tabs). Data that was already fetched should stay
    // on screen — making the user press "Load" on every visit made the page look
    // empty and risked paying for the same pull twice.
    React.useEffect(() => {
      let alive = true;
      const c = dom && _blCache[dom];
      if (c) {
        setStarted(true); setBl(c.bl); setLoaded(true); setRefs(c.refs); setOpps(c.opps);
        setOppsLoading(false); setRestoring(false);
        return () => { alive = false; };
      }
      setStarted(false); setBl(null); setLoaded(false); setRefs(null); setOpps(null); setOppsLoading(false);
      if (!dom) { setRestoring(false); return () => { alive = false; }; }
      setRestoring(true);
      // cached=1 → the server answers from KV only; it never calls DataForSEO.
      Promise.all([
        window.SGLive.fetchBacklinks(dom, true),
        window.SGLive.fetchReferringDomains(dom, 50, true),
        window.SGLive.fetchBacklinkOpportunities(dom, true),
      ]).then(([b, r, o]) => {
        if (!alive) return;
        if (b) {
          const entry = (_blCache[dom] = _blCache[dom] || {});
          entry.bl = b; entry.refs = r || []; if (o && o.ok) entry.opps = o;
          setBl(b); setLoaded(true); setRefs(r || []);
          if (o && o.ok) setOpps(o);
          setStarted(true);
        }
        setRestoring(false);
      }).catch(() => { if (alive) setRestoring(false); });
      return () => { alive = false; };
    }, [dom]);
    const load = () => {
      setStarted(true); setOppsLoading(true);
      const entry = (_blCache[dom] = _blCache[dom] || {});
      window.SGLive.fetchBacklinks(dom).then((d) => { setBl(d); setLoaded(true); entry.bl = d; });
      window.SGLive.fetchReferringDomains(dom, 50).then((d) => { setRefs(d); entry.refs = d; });
      window.SGLive.fetchBacklinkOpportunities(dom).then((d) => { setOpps(d); setOppsLoading(false); entry.opps = d; });
    };
    // Force a fresh pull, ignoring everything cached.
    const refresh = () => { if (dom) delete _blCache[dom]; load(); };
    const hasRefs = refs && refs.length > 0;
    if (locked) {
      return (
        <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <PageHead eyebrow="Research" title="Backlinks" icon="link" sub="Referring domains and links pointing to your site." />
          <window.SGLive.PaidLock title="Backlinks unlock on a paid plan" blurb="Your full backlink profile and referring-domains list use premium data. Upgrade to see who links to you, your domain authority and broken links." />
        </div>
      );
    }
    if (restoring) {
      return (
        <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <PageHead eyebrow="Research" title="Backlinks" icon="link" sub="Referring domains and links pointing to your site." />
          <Card style={{ padding: '56px 24px', textAlign: 'center', color: 'var(--sg-text-2)', fontSize: 13.5 }}>Loading your saved backlink data…</Card>
        </div>
      );
    }
    // Lazy gate: backlink data is a paid DataForSEO pull — load on demand.
    if (!started) {
      return (
        <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <PageHead eyebrow="Research" title="Backlinks" icon="link" sub="Referring domains and links pointing to your site." />
          <Card style={{ padding: '56px 24px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
            <span style={{ width: 60, height: 60, borderRadius: 'var(--sg-radius-xl)', background: 'var(--sg-blue-50)', color: 'var(--sg-blue-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="link" size={28} /></span>
            <div style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 600, fontSize: 21, color: 'var(--sg-text)' }}>Load backlinks for {dom || 'this domain'}</div>
            <div style={{ fontSize: 13.5, color: 'var(--sg-text-2)', maxWidth: 480, lineHeight: 1.55 }}>This pulls your live backlink profile, referring domains and link-building opportunities from DataForSEO. We cache it for a week, so loading again is free.</div>
            <button onClick={load} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 46, padding: '0 24px', marginTop: 4, border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 14.5, color: '#fff', background: 'var(--sg-grad-brand)', boxShadow: '0 4px 16px rgba(37,99,235,0.32)' }}>
              <Icon name="activity" size={17} /> Load backlink data
            </button>
          </Card>
        </div>
      );
    }
    const liveStats = bl ? [
      { label: 'Referring domains', value: (bl.referring_domains ?? 0).toLocaleString() },
      { label: 'Domain rank', value: String(bl.domain_rank ?? '—'), sub: '/1000' },
      { label: 'Total backlinks', value: bl.total_backlinks != null ? bl.total_backlinks.toLocaleString() : '—' },
      { label: 'Referring IPs', value: (bl.referring_ips ?? 0).toLocaleString() },
      { label: 'Broken links', value: String(bl.broken_backlinks ?? 0), warn: (bl.broken_backlinks ?? 0) > 0 },
    ] : [
      { label: 'Referring domains', value: '—' }, { label: 'Domain rank', value: '—', sub: '/1000' },
      { label: 'Total backlinks', value: '—' }, { label: 'Referring IPs', value: '—' }, { label: 'Broken links', value: '—' },
    ];
    return (
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
        <PageHead eyebrow="Research" title="Backlinks" icon="link" sub="Referring domains and links pointing to your site." />
        {bl
          ? <Card style={{ padding: 16, display: 'flex', alignItems: 'center', gap: 12, background: 'var(--sg-green-50)', border: '1px solid var(--sg-green-100, #CDEBD6)' }}>
              <Icon name="check" size={18} color="var(--sg-green)" />
              <div style={{ flex: 1, fontSize: 13, color: 'var(--sg-text)' }}><strong>● Live.</strong> Real backlink profile and referring-domains list from DataForSEO. Kept until you refresh it.</div>
              <button onClick={refresh} title="Pull fresh data from DataForSEO"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 32, padding: '0 14px', borderRadius: 'var(--sg-radius-pill)', border: '1px solid var(--sg-border)', background: 'var(--sg-card)', color: 'var(--sg-text)', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12 }}>
                <Icon name="activity" size={13} /> Refresh
              </button>
            </Card>
          : <Card style={{ padding: 16, display: 'flex', alignItems: 'center', gap: 12, background: 'var(--sg-amber-50)', border: '1px solid var(--sg-amber-100, #F6E6C7)' }}>
              <Icon name="info" size={18} color="var(--sg-amber)" />
              <div style={{ flex: 1, fontSize: 13, color: 'var(--sg-text)' }}>{loaded ? 'No backlink data found for this domain yet (new or low-authority site).' : 'Loading your backlink profile from DataForSEO…'}</div>
            </Card>}
        <StatRow stats={liveStats} />
        <Opportunities data={opps} loading={oppsLoading} you={dom} />
        <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 20, alignItems: 'stretch' }}>
          <NewLostTrend refs={refs} />
          <ToxicCallout bl={bl} />
        </div>
        <Card>
          <CardHead title="Referring domains" sub={bl ? `${(bl.referring_domains ?? 0).toLocaleString()} domains linking to you` : 'Domains linking to you'}
            right={hasRefs ? <span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span> : null} />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px 70px 110px 110px 90px', gap: 14, padding: '10px 20px', borderBottom: '1px solid var(--sg-border)', fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)' }}>
            <span>Domain</span><span>Authority</span><span>Links</span><span>First seen</span><span>Type</span><span>Status</span>
          </div>
          {hasRefs
            ? refs.map((r, i) => <LiveDomainRow key={i} r={r} last={i === refs.length - 1} />)
            : <div style={{ padding: '22px 20px', fontSize: 13, color: 'var(--sg-text-2)' }}>No referring domains found for this site yet — use the link-building opportunities above to start earning them.</div>}
        </Card>
      </div>
    );
  }

  window.SGBacklinks = Backlinks;
})();
